import { StrictMode, Component, type ReactNode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

window.onerror = (msg, _url, _line, _col, error) => {
  console.error('Global error:', msg, error)
  const el = document.getElementById('root') || document.body
  el.innerHTML = '\u003cdiv style="padding:40px;font-family:sans-serif;background:#F4EFE6;color:#1C1814"\u003e\u003ch1\u003eJS Error\u003c/h1\u003e\u003cpre\u003e' + String(msg) + '\u003c/pre\u003e\u003c/div\u003e'
  return true
}

window.onunhandledrejection = (event) => {
  console.error('Unhandled rejection:', event.reason)
  const el = document.getElementById('root') || document.body
  el.innerHTML = '\u003cdiv style="padding:40px;font-family:sans-serif;background:#F4EFE6;color:#1C1814"\u003e\u003ch1\u003ePromise Rejection\u003c/h1\u003e\u003cpre\u003e' + String(event.reason) + '\u003c/pre\u003e\u003c/div\u003e'
}

class ErrorBoundary extends Component<{ children: ReactNode }, { hasError: boolean; error: Error | null }> {
  constructor(props: { children: ReactNode }) {
    super(props)
    this.state = { hasError: false, error: null }
  }
  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error }
  }
  override componentDidCatch(error: Error, errorInfo: object) {
    console.error('NOREN fatal render error:', error, errorInfo)
  }
  override render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 40, fontFamily: 'Archivo, sans-serif', background: '#F4EFE6', minHeight: '100vh', color: '#1C1814' }}>
          <h1 style={{ fontSize: 20, marginBottom: 16 }}>Something went wrong</h1>
          <pre style={{ background: '#EBE3D5', padding: 16, borderRadius: 4, color: '#C24A2C', fontSize: 12, overflow: 'auto' }}>
            {this.state.error?.message}
          </pre>
        </div>
      )
    }
    return this.props.children
  }
}

const rootEl = document.getElementById('root')
if (!rootEl) {
  document.body.innerHTML = '<div style="padding:40px;font-family:sans-serif">Root element #root not found</div>'
  throw new Error('Root element #root not found in DOM')
}

createRoot(rootEl).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
)